// // src/Translate/TranslatedText.js
// import React, { useContext, useState, useEffect } from 'react';
// import { TranslationContext } from '../context/TranslationContext';

// const TranslatedText = ({ children, component: Component = 'span', ...props }) => {
//   const { currentLanguage, translate } = useContext(TranslationContext);
//   const [translatedText, setTranslatedText] = useState(children);
  
//   useEffect(() => {
//     console.log('TranslatedText effect triggered');
//     console.log('Children:', children);
//     console.log('Current language:', currentLanguage);
    
//     if (currentLanguage !== 'en' && children && typeof children === 'string') {
//       console.log('Attempting to translate:', children);
//       translate(children).then(translated => {
//         console.log('Translation result:', translated);
//         setTranslatedText(translated);
//       });
//     } else {
//       console.log('Not translating, using original text');
//       setTranslatedText(children);
//     }
//   }, [children, currentLanguage, translate]);
  
//   return <Component {...props}>{translatedText}</Component>;
// };

// export default TranslatedText;
import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { API_URL, LanguageContext } from "../utils";

const TranslatedText = ({ children }) => {
  const { language } = useContext(LanguageContext);
  const [translated, setTranslated] = useState(children);

  useEffect(() => {
    const translate = async () => {
      if (language === "en") {
        setTranslated(children);
        return;
      }

      // try {
      //   const response = await axios.post(`${API_URL}/website/language-translate`, {
      //     text: children,
      //     target_lang: language,
      //   });

      //   setTranslated(response.data.text);
      // } catch (error) {
      //   console.error("Translation error:", error);
      //   setTranslated(children);
      // }
    };

    translate();
  }, [language, children]);

  return <>{translated}</>;
};

export default TranslatedText;
